module.exports = __webpack_public_path__ + "static/media/3_evenement.1ad69ab9.jpg";